export default {
      id: "shevron-left-usage",
      viewBox: "0 0 8 13",
      url: __webpack_public_path__ + "icons.svg#shevron-left",
      toString: function () {
        return this.url;
      }
    }